import FormTpl from '../../../components/FormTpl/index'
import eventHub from '../../../utils/eventHub'
import mapSchemas from '../../../utils/mapSchemas'

export default {
  name: 'EditPage',
  render(h) {
    return (
      <div class="sp-card">
        <FormTpl
          class="sp-edit-page-form"
          style={{ minWidth: 300 }}
          model={this.formData}
          fields={this.editableSchema}
          options={{ disabled: this.isDetail }}
        />
        {this.nestedList && this.nestedList.map(v => h(v))}
        {
          this.isDetail ? (
            <div style={{ marginTop: 'var(--card-spacing)' }}>
              <el-button on-click={this.cancel}>{this.$i18n('Back')}</el-button>
            </div>
          ) : (
            <div style={{ marginTop: 'var(--card-spacing)' }}>
              <el-button on-click={this.cancel}>{this.$i18n('Cancel')}</el-button>
              <el-button type="primary" on-click={this.confirm}>{this.$i18n('Confirm')}</el-button>
            </div>
          )
        }
      </div>
    )
  },
  data() {
    return {
      cancelText: this.$i18n('Confirm Cancel ?'),
      confirmText: this.$i18n('Confirm ?'),
      confirming: false,
      defaultFormData: {}
    }
  },
  computed: {
    ...mapSchemas(),
    formData() {
      return this.model || this.defaultFormData
    }
  },
  props: ['schema', 'data', 'model', 'isDetail', 'nestedList', 'close'],
  methods: {
    reset() {
      this.filterSchema.forEach(item => {
        this.defaultFormData[item.key] = item.options.defaultValue
      })
    },
    cancel() {
      this.$confirm(this.cancelText)
        .then(() => this.close())
        .catch(() => {})
    },
    confirm() {
      if (this.confirming) return
      this.confirming = true
      const resourceName = this.data.resourceName.toLocaleLowerCase() + '_id'
      this.formData[resourceName] = this.formData[resourceName] || this.formData['id']
      this.$confirm(this.confirmText).then(async () => {
        if (this.model) {
          if (this.data && this.data.update) {
            await this.data.update(this.$store, this.formData)
          }
        } else {
          if (this.data && this.data.add) {
            await this.data.add(this.$store, this.formData)
          }
        }
        this.close()
        this.confirming = false
      }).catch(() => this.confirming = false)
    }
  }
}



// WEBPACK FOOTER //
// ./packages/creator/ListView/add/embedAdd.js